import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  #config = {
    applicationTitle: '',
    applicationLogo: '',
    laboratoryName: '',
    laboratoryAddress: '',
    laboratoryPhone: '',
    laboratoryEmail: ''
  }

    public get title() {
        return this.#config.applicationTitle;
    }

    public set title(title) {
      this.#config.applicationTitle = title;
    }


    public get logo() {
        return this.#config.applicationLogo;
    }

    public set logo(logo) {
      this.#config.applicationLogo = logo;
    }

    public get lab() {
        return this.#config.laboratoryName;
    }

    public set lab(name) {
      this.#config.laboratoryName = name;
    }

    public get labAddress() {
        return this.#config.laboratoryAddress;
    }

    public set labAddress(address) {
      this.#config.laboratoryAddress = address;
    }

    public get labPhone() {
        return this.#config.laboratoryPhone;
    }

    public set labPhone(phone) {
      this.#config.laboratoryPhone = phone;
    }

    public get email() {
        return this.#config.laboratoryEmail;
    }

    public set email(name) {
      this.#config.laboratoryEmail = name;
    }
}
